
<validation-observer v-slot="{ invalid }" slim>
  <div 
    @close="handleClose" 
    @confirm="handleCloseConfirmation" 
    class="checkout-custom-modal"
    :class="centralizedModals.includes(stepComponent) ? 'modal-centralized' : ''" 
    :showCloseButton="false"
  >
  
    <div slot="header" class="container">
      <header class="header-quote flex justify-between items-center px-4">
        <h4 class="flow-header-title">
          <slot name="title ">{{ headerText }}</slot>
        </h4>
        <a class="close-icon flex items-center justify-center" @click.prevent="handleClose">
          <icon type="x-close" />
        </a>
      </header>
      <step-tabs v-if="quoteSteps.includes(stepComponent)" :current="stepComponent" :steps="steps" />
    </div>

    <div v-if="prompt" slot="prompt" class="w-full h-[75%] flex flex-col items-center justify-center font-rubik">
      <h5 class="font-semibold text-lg 1170-bp:text-2xl">Are you sure you'd like to leave?</h5>
      <div class="flex gap-8 mt-8">
        <button @click="handleCloseConfirmation" class="w-[111px] 1170-bp:w-[222px] h-[44px] rounded-full border border-red-500 bg-red-500 transition-all">
          <p class="white text-white">Yes</p>
        </button>
        <button @click="prompt = !prompt" class="w-[111px] 1170-bp:w-[222px] h-[44px] rounded-full border border-[#4D84FF] bg-[#4D84FF] transition-all">
          <p class="white text-white">No</p>
        </button>
      </div>
    </div>

    <div v-if="!prompt" class="flex flex-col justify-between" style="height: calc(100% - 185px) !important;">
      
      <div :class="stepComponent != 'options' ? 'component-slot' : ''" slot="body">
        <component :is="stepComponent" ref="stepComponent" @next="next" @close="handleClose"
          @enabled="(enabled) => disabled = !enabled">
        </component>
      </div>

      <div  slot="footer" class="flex flex-col">
        <div class="summary-totals" v-if="quote && ['options', 'checkout', 'confirmation'].includes(stepComponent)">
          <!--<quote-totals />-->
        </div>

        <div class="buttons-container">
          <div v-if="customSize">
            <button @click="backToHome" class="button custom-action-button is-fullwidth transition-all">
              <p>Back to Home</p>
            </button>
          </div>
          <div v-else>
            <div class="level is-mobile">
              <template v-if="isComplete">
                <div class="level-item">
                  <a href="/solutions/container-sales" class="button custom-close-button is-fullwidth transition-all">
                    <p>See Other Containers</p>
                  </a>
                  <button @click="handleClose" class="button custom-action-button is-fullwidth transition-all">
                    <p>Close</p>
                  </button>
                </div>
              </template>
              <template v-else>
                <div v-if="canGoBack" class="level-item is-halfwidth">
                  <button @click="back()" class="button custom-close-button is-fullwidth transition-all">
                    <p>Back</p>
                  </button>
                </div>
                <div class="level-item is-halfwidth">
                  <button @click="next" :disabled="invalid || disabled || loading"
                    :class="[
                      'is-fullwidth custom-action-button transition-all flex justify-center items-center',
                      {'is-loading': loading},
                      {'cursor-not-allowed' : (invalid || disabled || loading)}
                    ]"
                  >
                    <p>{{ nextButtonText }}</p>
                  </button>
                </div>
              </template>
            </div>
            <div v-if="(stepComponent == 'options' || stepComponent == 'email-quote') && showPrice" class="is-fullwidth">
              <p class="neutral-gray has-text-weight-semibold text-sm mb-2 has-text-centered">
                Ready to make a purchase?
              </p>
              <button @click="reserveOrder" class="button custom-action-button is-fullwidth transition-all"
                :disabled="invalid || disabled || loading" :class="{ 'is-loading': loading }">
                <p>Reserve Order</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</validation-observer>
